// @ts-nocheck
import React from "react";
import { globalPermissionValidator } from "modules/look";
import { Spin } from "antd";
import RewardSystemHomeView from "../components/reward-system-home-view";
import { reward_system_permission } from "Permissions/rewardPermissions.permission";

const RewardSystemHomeContainer = (props) => {
    const { userPermission, setAppSidebarExpand } = props
    const [rewardPermission, setRewardPermission] = React.useState()
    const [permission_loading, setPermissionLoading] = React.useState(false)

    React.useEffect(() => {

        if (userPermission?.length) {
            let permission = globalPermissionValidator(
                reward_system_permission,
                userPermission);
            setRewardPermission(permission)
            setPermissionLoading(false)

        }
    }, [userPermission])

    React.useEffect(() => {
        if (setAppSidebarExpand) {
            setAppSidebarExpand(false)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <Spin spinning={permission_loading} size='large'>
            <RewardSystemHomeView
                rewardPermission={rewardPermission}
                {...props}
            />
        </Spin>
    )
}

export default RewardSystemHomeContainer;